import axios from 'axios';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const API = `${BACKEND_URL}/api`;

// Create axios instance with defaults
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Contact form submission
export const submitContact = async (data) => {
  const response = await apiClient.post('/contact', data);
  return response.data;
};

// Waitlist signup
export const joinWaitlist = async (data) => {
  const response = await apiClient.post('/waitlist', data);
  return response.data;
};

// Admin login
export const adminLogin = async (password) => {
  const response = await apiClient.post('/admin/login', { password });
  return response.data;
};

// Create authenticated client
const createAuthClient = (token) => {
  return axios.create({
    baseURL: API,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
};

// Admin - Get contacts
export const getContacts = async (token, skip = 0, limit = 50) => {
  const client = createAuthClient(token);
  const response = await client.get(`/admin/contacts?skip=${skip}&limit=${limit}`);
  return response.data;
};

// Admin - Export contacts
export const exportContacts = async (token) => {
  const client = createAuthClient(token);
  const response = await client.get('/admin/contacts/export', {
    responseType: 'blob',
  });
  return response.data;
};

// Admin - Get waitlist
export const getWaitlist = async (token, skip = 0, limit = 50) => {
  const client = createAuthClient(token);
  const response = await client.get(`/admin/waitlist?skip=${skip}&limit=${limit}`);
  return response.data;
};

// Admin - Export waitlist
export const exportWaitlist = async (token) => {
  const client = createAuthClient(token);
  const response = await client.get('/admin/waitlist/export', {
    responseType: 'blob',
  });
  return response.data;
};

// Admin - Get stats
export const getStats = async (token) => {
  const client = createAuthClient(token);
  const response = await client.get('/admin/stats');
  return response.data;
};

export default apiClient;
